import { api, errorBanner, loadingBanner } from "../api.js";
import { navigate, replaceQuery } from "../router.js";
import { renderHouseTabs, bindHouseTabs } from "../components/segmented.js";
import { renderPropositionCard } from "../components/propcard.js";
import { renderMemberCard } from "../components/membercard.js";

export async function renderHome({ root, query, isCurrent }) {
  document.title = "Como Vota · Câmara e Senado";
  const state = { house: query.house || "" };
  root.innerHTML = `
    <section class="hero">
      <div class="hero__art"><img src="/logo-mark.svg" alt="" /></div>
      <div>
        <span class="eyebrow-pill">Pense sobre…</span>
        <h1 class="hero__title">Você lembra qual foi o último parlamentar que você <strong>votou para te representar?</strong></h1>
        <p class="hero__text">Se a resposta é “não”, como pode saber se está sendo bem representado na Câmara ou no Senado?</p>
        <div class="hero__actions">
          <a class="btn btn--primary" href="/proposicoes?sort=voted" data-link>Podemos ajudar!</a>
          <a class="inline-link" href="/metodologia" data-link>Entenda o projeto!</a>
        </div>
        <form class="searchbar" data-search-form role="search">
          <input type="search" name="q" placeholder="Buscar proposição ou tema…" aria-label="Buscar" autocomplete="off" />
          <button type="submit" class="btn btn--primary">Buscar</button>
        </form>
      </div>
    </section>

    <section class="home-section">
      <span class="eyebrow-pill">O problema</span>
      <p class="home-section__lede">É muito comum não levarmos os votos a sério, principalmente quando não estamos pensando em votos para presidente. O que fica é a pergunta…</p>
      <h2 class="section-title section-title--caps section-title--block">Como ajudamos a fazer as pessoas entenderem a importância de seus votos?</h2>
      <div class="pillars">
        <div class="pillar"><h3>De olho no processo</h3><p>Além de trazer as informações direto da Câmara dos Deputados e do Senado Federal, explicamos o passo a passo de como elas chegaram e quais os próximos passos.</p></div>
        <div class="pillar"><h3>Menos “juridiquês”</h3><p>Todos os documentos oficiais são apresentados, mas nem sempre é fácil ou prático entendê-los. Por isso ajudamos com resumos das propostas.</p></div>
        <div class="pillar"><h3>Acompanhe seus representantes</h3><p>Como cada deputado e senador tem votado, suas presenças e vieses, comparados com a mediana da Casa.</p></div>
      </div>
    </section>

    <section class="home-section">
      <span class="eyebrow-pill">Propostas</span>
      <h2 class="section-title section-title--caps section-title--block">Em votação</h2>
      <p class="home-section__lede">As proposições votadas mais recentemente na Câmara e no Senado. Clique para ver o resumo, o texto completo e a linha do tempo.</p>
      ${renderHouseTabs(state.house)}
      <div data-cards>${loadingBanner()}</div>
    </section>

    <section class="home-section">
      <span class="eyebrow-pill">Parlamentares</span>
      <h2 class="section-title section-title--caps section-title--block">Acompanhe seus representantes</h2>
      <p class="home-section__lede">Procure por estado ou partido e tenha certeza de como seu voto está sendo traduzido nas votações dentro da Câmara e do Senado.</p>
      <div data-members>${loadingBanner()}</div>
      <p class="home-voted__more"><a class="card__link" href="/parlamentares" data-link>Ver todos os parlamentares →</a></p>
    </section>`;

  root.querySelector("[data-search-form]").addEventListener("submit", (e) => {
    e.preventDefault();
    const q = e.target.q.value.trim();
    navigate(q ? `/busca?q=${encodeURIComponent(q)}` : "/busca");
  });

  const cards = root.querySelector("[data-cards]");
  const membersEl = root.querySelector("[data-members]");
  bindHouseTabs(root, (house) => {
    state.house = house;
    replaceQuery(state);
    loadVoted();
  });

  async function loadVoted() {
    cards.innerHTML = loadingBanner();
    try {
      const page = await api.propositions({ sort: "voted", house: state.house, page_size: 12 });
      if (!isCurrent()) return;
      if (!page.items?.length) {
        cards.innerHTML = `<div class="empty-card">Nenhuma votação encontrada para esse filtro.</div>`;
        return;
      }
      const more = `/proposicoes?sort=voted${state.house ? `&house=${state.house}` : ""}`;
      cards.innerHTML = `
        <ul class="card-grid">${page.items.map((p) => renderPropositionCard(p, { dateField: "last_roll_call_at" })).join("")}</ul>
        <p class="home-voted__more"><a class="card__link" href="${more}" data-link>Ver todas as proposições votadas →</a></p>`;
    } catch (err) {
      if (!isCurrent()) return;
      cards.innerHTML = errorBanner(err);
    }
  }

  async function loadMembers() {
    try {
      const page = await api.members({ in_exercise: "true", sort: "attendance", page_size: 8 });
      if (!isCurrent()) return;
      membersEl.innerHTML = page.items?.length
        ? `<ul class="card-grid card-grid--members">${page.items.map(renderMemberCard).join("")}</ul>`
        : `<div class="empty-card">Nenhum parlamentar encontrado.</div>`;
    } catch (err) {
      if (!isCurrent()) return;
      membersEl.innerHTML = errorBanner(err);
    }
  }

  await Promise.all([loadVoted(), loadMembers()]);
}
